import React, { useContext } from "react";
import classes from "./Social.module.css";
import { RiGithubLine } from "react-icons/ri";
import { FiLinkedin } from "react-icons/fi";
import { RiTwitterLine } from "react-icons/ri";
import { ThemeContext } from "../../ThemeProvider";
import { motion } from "framer-motion";

const Social = () => {
  const { dark } = useContext(ThemeContext);

  const animateFrom = { opacity: 0, y: 40 };
  const animateTo = { opacity: 1, y: 0 };

  return (
    <motion.section
      className={classes.social}
      initial={animateFrom}
      animate={animateTo}
      transition={{ delay: 1.7, duration: 0.7 }}
    >
      <div className={classes.social__icons}>
        <div className={classes.social__left}>
          <ul>
            <li className={classes.gitHub}>
              <a href="https://github.com/partharoyy" target="_blank">
                <RiGithubLine
                  className={
                    dark
                      ? `${classes.icon__item} ${classes.icon__item__dark} `
                      : classes.icon__item
                  }
                />
              </a>
            </li>
            <li className={classes.twitter}>
              <a href="https://twitter.com/roypartha0512" target="_blank">
                <RiTwitterLine
                  className={
                    dark
                      ? `${classes.icon__item} ${classes.icon__item__dark} `
                      : classes.icon__item
                  }
                />
              </a>
            </li>

            <li className={classes.linkedIn}>
              <a
                href="https://www.linkedin.com/in/partha-roy-58939564/"
                target="_blank"
              >
                <FiLinkedin
                  className={
                    dark
                      ? `${classes.icon__item} ${classes.icon__item__dark} `
                      : classes.icon__item
                  }
                />
              </a>
            </li>
          </ul>
          <div
            className={
              dark
                ? `${classes.bottomLine1} ${classes.bottomLine__dark}`
                : classes.bottomLine1
            }
          ></div>
        </div>
        <div className={classes.social__right}>
          <a href="mailto:partharoyy44@gmail.com">
            <p
              className={
                dark
                  ? `${classes.icon__item} ${classes.icon__item__dark} `
                  : classes.icon__item
              }
            >
              partharoyy44@gmail.com
            </p>
          </a>

          <div
            className={
              dark
                ? `${classes.bottomLine2} ${classes.bottomLine__dark}`
                : classes.bottomLine2
            }
          ></div>
        </div>
      </div>
    </motion.section>
  );
};

export default Social;
